<template>
  <div class="richtext">
    <!-- <textarea id="editor" rows="10" cols="80"></textarea> -->
    <textarea id="editor" :rows="ckeRows" :cols="ckeCols"></textarea>
  </div>
</template>

<script>
import CKEDITOR from 'CKEDITOR';
export default {
  name: 'richtext',
  data(){
    return {
      content:'',
    };
  },
  props: {
    ckeHeight: String,  //textarea高度
    ckeWidth: String, //textarea宽度
    ckeRows: String, //textarea行数
    ckeCols: String, //textarea列数
    ckContent: String, //父组件传过来的内容
  },
  methods:{
    setContent () {
      CKEDITOR.instances.editor.setData(this.content)
    },
    getContent () {
      // 参照vue子组件传值给父组件
      this.$emit('catchData', CKEDITOR.instances.editor.getData())
    },
    emptyContent(){
      this.content = '';
      this.setContent();
    }
  },
  mounted() {
    this.content=this.ckContent;
    // const cke = CKEDITOR.replace('ck-editor', {height: '400px', width: '100%', toolbar: 'toolbar_Full'});
    const cke = CKEDITOR.replace('editor', { height: this.ckeHeight, width: this.ckeWidth, toolbar: 'toolbar_Full', });
    //  CKEditor 初始化完成加载数据
    cke.on('instanceReady', e => {
      // console.log(e);
      this.setContent()
    })

    //  CKEditor 数据改变-监听 （用于子组件像父组件传值）
    CKEDITOR.instances.editor.on('change', e => {
      // console.log(e);
      this.getContent()
    })
    // this.editor = CKEDITOR.instances.editor;//不知道这句话干什么用，先注掉了
    cke.on('fileUploadRequest', function (evt) {
      let xhr = evt.data.fileLoader.xhr;
      // console.log('文件上传请求：', evt);
      xhr.setRequestHeader('Cache-Control', 'no-cache');
      let accessToken = localStorage.getItem('Authorization');
      if (accessToken) {
        xhr.setRequestHeader('Authorization', `${localStorage.getItem('Authorization')}`);
      }
      xhr.withCredentials = true;
    });
  },
  // watch: {
  //   ckContent: {
  //     immediate: true,    // 这句重要
  //     handler (val) {
  //         this.content=val;
  //         this.setContent();
  //     }
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
